export default "__VITE_ASSET__DTMP3uxf__"